@import "@/styles/variables";

.layout {
	display: flex;
	height: 100%;
	background: $gray-50;

	@media (max-width: 1024px) {
		flex-direction: column;
	}
}

.mainContent {
	flex: 1;
	overflow-y: auto;
	padding: 1rem;

	@media (max-width: 768px) {
		padding: 1rem;
	}
}

.emptyState {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	min-height: 400px;
	padding: 3rem 1.5rem;
	text-align: center;
}

.emptyIcon {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 80px;
	height: 80px;
	margin: 0 auto 1.5rem;
	background: $primary-light;
	border-radius: 50%;
	color: $primary-color;
}

.emptyTitle {
	font-size: 1.5rem;
	font-weight: 600;
	color: $gray-700;
	margin: 0 0 0.75rem 0;
}

.emptyDescription {
	font-size: 1rem;
	color: $gray-500;
	margin: 0;
	max-width: 400px;
}
